import { VIEW_EXPENSES_SUCCESS } from '../constants';

const initialState = {
  expenses: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case VIEW_EXPENSES_SUCCESS:
      return { ...state, expenses: action.data };
    default:
      return state;
  }
};

export default reducer;
